import { Box } from '@mui/system'
import { Typography } from '@mui/material'
import { useHistory } from 'react-router-dom'
import PasswordResetIconImage from '../../images/passwordResetIcon.svg'
import OfoqThemeBtn from '../../components/Buttons/OfoqThemeBtn.jsx'
import UseTranslation from '../../hooks/UseTranslation.jsx'
import CookiesStorageService from '../../services/CookiesStorageService'
import AppRoutes from '../../services/AppRoutes'

const Success = () => {
  const history = useHistory()
  const { t } = UseTranslation()

  const handleClick = () => {
    CookiesStorageService.clearCookies()
    history.push(AppRoutes.login)
  }
  return (

      <Box sx={styles.leftSideContainer}>
        <Box component={'img'} src={PasswordResetIconImage} alt='PasswordResetIconImage' sx={styles.passwordResetIconImage} />

        <Typography variant={'h4'} sx={styles.formTitle}>
          {t?.['Your Password has been Saved Successfully']}
        </Typography>

        <Typography component={'p'} sx={styles.formSubTitle}>
          {t?.['Now you can log in with the new password and continue using our platform.']}
        </Typography>
        <Box sx={styles.formBtns}>
          <OfoqThemeBtn customStyle={styles.continueBtn}
            name={t?.['Move to Log in']}
           onClick={handleClick}
          />
        </Box>
      </Box>
  )
}

const styles = {

  leftSideContainer: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: { xs: '100%', sm: '300px', md: '550px' },
    marginTop: { xs: '30px', sm: '50px' },
    mx: { xs: '0px', sm: '40px' },
    px: '10px',
    zIndex: '2',
  },

  formTitle: {
    color: 'primary.contrastText',
    fontSize: { xs: '24px', sm: '28px' },
    mb: { xs: '10px', sm: '30px' },
    lineHeight: { xs: '35px', sm: '47px' },
    fontWeight: 500,
  },
  formSubTitle: {
    fontSize: { xs: '12px', sm: '14px' },
    mb: { xs: '20px', sm: '30px' },
  },
  formBtns: {
    display: 'flex',
    minWidth: '100%',
    justifyContent: { xs: 'center', sm: 'flex-end' },
    marginTop: { xs: '10px', sm: '30px' },
  },
  continueBtn: {
    maxWidth: { xs: '100%', sm: '189px' },
    height: '40px',
  },

  passwordResetIconImage: { width: '100px', height: '100px', mb: '40px' },
}

export default Success
